export enum HTTP_METHOD {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}

export const ACTIVATION_STATUS = {
  0: '有効',
  1: '無効',
};

export const CREATE_DB_NAME_DEFAULT_VALUE = {
  db_name: '',
  appId: '',
  name: '',
  size: 200000,
  retentionPeriod: 90,
  lowThreshold: 0.5,
  highThreshold: 0.75,
  referenceThreshold: 0.4,
};

export const APPLICATION_SUMMARY_DEFAULT_VALUE = {
  id: 0,
  appId: '',
  appName: '',
  username: '',
  ssidId: '',
  ssidName: '',
  userId: '',
  privateDbInitSize: 90,
  maxPrivateDb: 20,
  privateDbCount: 0,
  clusterDbCount: 0,
  numApiCall: 0,
  numDb: 0,
};

export const DB_TYPE_OPTS: Option[] = [
  { label: 'Private DB', value: 'private' },
  { label: 'Cluster DB', value: 'cluster' },
];

export const API_FORM_DEFAULT_VALUE = {
  name: '',
  description: '',
  ssidPath: '',
  dataSchema: {},
  apiCategory: '',
  hasCheckFeatureDb: false,
  hasSearchFeatureDb: false,
  hasCreateFeatureDb: false,
  hasDeleteFeatureDb: false,
  hasCreateFeature: false,
  hasDeleteFeature: false,
  displayOrder: 0,
  usageCount: 1,
};

export const JSON_EDITOR_DEFAULT_MESSAGE = {
  KEY_NEW: () => '新しいキーを入力',
  ERROR_KEY_EXISTS: () => 'キーは既に存在しています',
  ERROR_INVALID_JSON: () => 'データスキーマを入力してください。',
  ERROR_UPDATE: () => '更新に失敗しました',
  ERROR_DELETE: () => '削除に失敗しました',
  ERROR_ADD: () => 'ノードの追加に失敗しました',
  DEFAULT_STRING: () => '新しいデータ！',
  DEFAULT_NEW_KEY: () => 'キー',
};

export enum FACE_DB_TYPE {
  Private = 'private',
  Cluster = 'cluster',
}

export const APPROXIMATE_LICENSE_DB = {
  1: 'はい',
  0: 'いいえ',
};
